// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SectionWithSubscriptionBadge__root--dCUL {
    position: relative;
}

.SectionWithSubscriptionBadge__badge--mLgj {
    position: absolute;
    display: flex;
    border: 1px solid var(--main-color);
    border-radius: 4px;
    overflow: hidden;
    top: -20px;
    right: 50%;
    transform: translateX(50%);
    cursor: pointer;
}

@media screen and (min-width: 768px) and (max-width: 1024px) {

.SectionWithSubscriptionBadge__badge--mLgj {
        top: 24px;
        right: -8px;
        transform: none
}
    }

@media screen and (min-width: 1024px) {

.SectionWithSubscriptionBadge__badge--mLgj {
        top: 24px;
        right: -36px;
        transform: none
}
    }

.SectionWithSubscriptionBadge__text--p2NH {
    display: block;
    padding: 5px 11px;
    font-weight: 700;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0.03em;
    color: var(--main-color);
    text-transform: uppercase;
    background-color: var(--tertiary-color);
}

.SectionWithSubscriptionBadge__text--p2NH > strong {
        font-size: 13px;
        line-height: 16px;
        letter-spacing: 0%;
    }

.SectionWithSubscriptionBadge__icon--IizF {
    width: 38px;
    height: 38px;
    padding: 7px;
    background-color: var(--main-color);
    color: var(--tertiary-color);
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/SectionWithSubscriptionBadge/SectionWithSubscriptionBadge.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,UAAU;IACV,0BAA0B;IAC1B,eAAe;AAanB;;AAXI;;AAXJ;QAYQ,SAAS;QACT,WAAW;QACX;AAQR;IAPI;;AAEA;;AAjBJ;QAkBQ,SAAS;QACT,YAAY;QACZ;AAER;IADI;;AAGJ;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,uCAAuC;AAO3C;;AALI;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;AAGJ;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mCAAmC;IACnC,4BAA4B;AAChC","sourcesContent":[".root {\n    position: relative;\n}\n\n.badge {\n    position: absolute;\n    display: flex;\n    border: 1px solid var(--main-color);\n    border-radius: 4px;\n    overflow: hidden;\n    top: -20px;\n    right: 50%;\n    transform: translateX(50%);\n    cursor: pointer;\n\n    @media (--small-tablet) {\n        top: 24px;\n        right: -8px;\n        transform: none;\n    }\n\n    @media (--large) {\n        top: 24px;\n        right: -36px;\n        transform: none;\n    }\n}\n\n.text {\n    display: block;\n    padding: 5px 11px;\n    font-weight: 700;\n    font-size: 10px;\n    line-height: 12px;\n    letter-spacing: 0.03em;\n    color: var(--main-color);\n    text-transform: uppercase;\n    background-color: var(--tertiary-color);\n\n    > strong {\n        font-size: 13px;\n        line-height: 16px;\n        letter-spacing: 0%;\n    }\n}\n\n.icon {\n    width: 38px;\n    height: 38px;\n    padding: 7px;\n    background-color: var(--main-color);\n    color: var(--tertiary-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SectionWithSubscriptionBadge__root--dCUL`,
	"badge": `SectionWithSubscriptionBadge__badge--mLgj`,
	"text": `SectionWithSubscriptionBadge__text--p2NH`,
	"icon": `SectionWithSubscriptionBadge__icon--IizF`
};
export default ___CSS_LOADER_EXPORT___;
